export const iconFontAwesomeHumanitarianTentArrowLeftRight = (
	<i className="fa-solid fa-tent-arrow-left-right"></i>
);
